import r from"./_baseClone.js";var e=4;function o(o){return r(o,e)}export{o as default};
//# sourceMappingURL=clone.js.map
